import { put, call } from 'redux-saga/effects';
import { termsFetch, termsAdd, termsUpdate, termsLoad, termsAccept } from '../services/termsService';

import * as types from '../actions';

export function* termsFetchSaga(payload) { // FOR SUPERADMIN ONLY
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(termsFetch, payload);
      yield put({ type: types.TERMS_FETCH_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.TERMS_FETCH_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* termsAddSaga(payload) { // FOR SUPERADMIN ONLY
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(termsAdd, payload);
      yield put({ type: types.TERMS_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.TERMS_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }     
}

export function* termsUpdateSaga(payload) { // FOR SUPERADMIN ONLY
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(termsUpdate, payload);
    yield put({ type: types.TERMS_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.TERMS_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* termsLoadSaga(payload) { // FOR AFFILIATES AND CLIENTS
    try {
        yield put({ type: types.SHOW_LOADER})
        const response = yield call(termsLoad, payload);
        yield put({ type: types.TERMS_LOAD_SUCCESS, response })
        
    } catch(error) {
        yield put({ type: types.TERMS_LOAD_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
}

export function* termsAcceptSaga(payload) { // FOR AFFILIATES AND CLIENTS
  try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(termsAccept, payload);
      yield put({ type: types.TERMS_ACCEPT_SUCCESS, response })
      
  } catch(error) {
      yield put({ type: types.TERMS_ACCEPT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

